// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/destructuring-assignment */
import React from "react"
import { connect } from "react-redux"
import Stack from "@kiwicom/orbit-components/lib/Stack"
import Text from "@kiwicom/orbit-components/lib/Text"
import styled from "styled-components" // eslint-disable-line no-restricted-imports
import RadioButtons from "@kiwicom/frontend-common/components/RadioButtons/RadioButtons"
import { toggleOption } from "@kiwicom/frontend-common/services/options/actions"

type Mode = {
  value: string
  label: string
}

type Props = {
  handleChange: () => void
  label: string
  modes: Mode[]
  active: number | string
}

const TextWrapper = styled.div`
  width: 50%;
`

const OptionToggleBtns = (props: Props) => (
  <Stack direction="row" justify="between">
    <TextWrapper>
      <Text>{`${props.label}: `}</Text>
    </TextWrapper>
    <RadioButtons {...props} />
  </Stack>
)

export default connect(
  (state, ownProps) => {
    // @ts-expect-error: Flow to TS migration.
    const optionState = state.options.get(ownProps.option)
    // @ts-expect-error: Flow to TS migration.
    const active = ownProps.checkActive ? ownProps.checkActive(optionState) : optionState
    return {
      active: active ? "enabled" : "disabled",
    }
  },
  (dispatch, ownProps) => ({
    handleChange: () => {
      // @ts-expect-error: Flow to TS migration.
      dispatch(toggleOption(ownProps.option))
      // @ts-expect-error: Flow to TS migration.
      if (ownProps.handleChange) {
        // @ts-expect-error: Flow to TS migration.
        ownProps.handleChange(dispatch)
      }
    },
  }),
)(OptionToggleBtns)
